import type { PanelProcess } from '../../../../../bridge/types/state.ts';

export function resolveProcessTitle(
	panelProcess: PanelProcess,
	fallback: string,
): string {
	const titleFromContent = (
		panelProcess.content as { title?: unknown } | undefined
	)?.title;
	if (
		typeof titleFromContent === 'string' &&
		titleFromContent.trim().length > 0
	) {
		return titleFromContent;
	}
	if (panelProcess.user_summary) return panelProcess.user_summary;
	return fallback;
}
